var map = {
	"./cny-flower.png": 2491,
	"./paper.png": 2492,
	"./prize-1-bm.webp": 2493,
	"./prize-1-cn.webp": 2494,
	"./prize-1.webp": 2495,
	"./prize-2-bm.webp": 2496,
	"./prize-2-cn.webp": 2497,
	"./prize-2.webp": 2498,
	"./prize-3-bm.webp": 2499,
	"./prize-3-cn.webp": 2500,
	"./prize-3.webp": 2501,
	"./prize-4-bm.webp": 2502,
	"./prize-4-cn.webp": 2503,
	"./prize-4.webp": 2504,
	"./prize-5-bm.webp": 2505,
	"./prize-5-cn.webp": 2506,
	"./prize-5.webp": 2507,
	"./star.svg": 2508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;